import store from '@/store';

export function getStore() {
  if (sessionStorage.getItem('store')) { // 在頁面載入時讀取sessionStorage裡的狀態資訊
    try {
      store.replaceState(Object.assign({}, store.state, JSON.parse(sessionStorage.getItem('store'))));
    } catch(err) {
      console.error(err);
    }
  }
}

export function saveStore() {
  try {
    sessionStorage.setItem('store', JSON.stringify(store.state));
  } catch(err) {
    console.error(err);
  }
}

export function clear() {
  try {
    sessionStorage.clear();
  } catch(err) {
    console.error(err);
  }
}
